import { render } from "./examRecordPaper.vue?vue&type=template&id=8badb5b6&scoped=true"
import script from "./examRecordPaper.vue?vue&type=script&lang=js"
export * from "./examRecordPaper.vue?vue&type=script&lang=js"

import "./examRecordPaper.vue?vue&type=style&index=0&id=8badb5b6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8badb5b6"]])

export default __exports__